import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './EducationOneTestimonialsTwo.scss'; // Your custom styl

 const EducationOneTestimonialsTwo = () => {
  const options = {
    loop: true,
    margin: 30,
    nav: true,
    dots: true,
    center: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 3,
      },
    },
  };

  return (
    <div className="EducationOneTestimonials-section">
      <div className="container">
      <div className="section-title">
        <h2>What Students Say</h2>
      </div>
      <OwlCarousel className="owl-theme" {...options}>
        <div className="testimonial-item">
          <p>
            “I had a positive experience with this healthcare center. Appointments were well managed, doctors were patient and thorough, and the nursing staff was kind. The overall environment felt safe, hygienic, and reliable.”
          </p>
          <div className="testimonial-author">
            <img src="https://plus.unsplash.com/premium_photo-1682089787056-9ac0c78a2ac2?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8aW5kaWFuJTIwcGVvcGxlfGVufDB8fDB8fHww" alt="David Warner" />
            <h3>Aarav</h3>
            <span>Art Director</span>
          </div>
        </div>

        <div className="testimonial-item highlighted">
          <p>
         “This hospital provided outstanding healthcare services. From check-in to discharge, the process was smooth. Doctors explained everything clearly, and nurses were compassionate. I felt well cared for and completely satisfied with my treatment.”
          </p>
          <div className="testimonial-author">
            <img src="https://media.istockphoto.com/id/1293903541/photo/young-woman-stock-photo.jpg?s=612x612&w=0&k=20&c=AvQGpGDrH-0nUNAL-uHuc1uidcTiiLbovyKJjsN_mOk=" alt="James Anderson" />
            <h3>Tanu</h3>
            <span>Designer</span>
          </div>
        </div>

        <div className="testimonial-item">
          <p>
          “The healthcare service was excellent, with professional doctors and attentive staff. The facilities were clean and well-equipped, ensuring comfort. I truly appreciated the quick diagnosis and supportive care provided throughout my treatment.”
          </p>
          <div className="testimonial-author">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyrmM7Ws8YyBws3bUwHwV5ZeG5Te7GicFNlQ&s" alt="Lina D'Souza" />
            <h3>Aarohi</h3>
            <span>Copywriter</span>
          </div>
        </div>
      </OwlCarousel>
    </div>
  </div>
  );
};

export default EducationOneTestimonialsTwo;
